// Body-map regions for the "tap where it hurts" check-in question type.
// Positions are on a 0–100 × 0–210 front-view silhouette. Left/right are as the
// athlete faces the screen (screen-left = "L"). Response is a comma-separated
// list of these keys, e.g. "wrist_l,low_back".
export const BODY_REGIONS = [
  { key: 'head',       label: 'Head',       x: 50, y: 12 },
  { key: 'neck',       label: 'Neck',       x: 50, y: 24 },
  { key: 'shoulder_l', label: 'L Shoulder', x: 35, y: 34 },
  { key: 'shoulder_r', label: 'R Shoulder', x: 65, y: 34 },
  { key: 'elbow_l',    label: 'L Elbow',    x: 26, y: 58 },
  { key: 'elbow_r',    label: 'R Elbow',    x: 74, y: 58 },
  { key: 'wrist_l',    label: 'L Wrist',    x: 22, y: 80 },
  { key: 'wrist_r',    label: 'R Wrist',    x: 78, y: 80 },
  { key: 'chest',      label: 'Chest',      x: 50, y: 44 },
  { key: 'low_back',   label: 'Low back',   x: 50, y: 66 },
  { key: 'hip_l',      label: 'L Hip',      x: 43, y: 82 },
  { key: 'hip_r',      label: 'R Hip',      x: 57, y: 82 },
  { key: 'knee_l',     label: 'L Knee',     x: 44, y: 130 },
  { key: 'knee_r',     label: 'R Knee',     x: 56, y: 130 },
  { key: 'ankle_l',    label: 'L Ankle',    x: 44, y: 172 },
  { key: 'ankle_r',    label: 'R Ankle',    x: 56, y: 172 },
];

export const REGION_LABEL = Object.fromEntries(BODY_REGIONS.map(r => [r.key, r.label]));

// 5-face scale — stored as 1..5 exactly like the numeric 'scale' type.
export const FACE_SCALE = [
  { v: 1, face: '😣', label: 'Rough' },
  { v: 2, face: '😕', label: 'Meh' },
  { v: 3, face: '😐', label: 'Okay' },
  { v: 4, face: '🙂', label: 'Good' },
  { v: 5, face: '😄', label: 'Great' },
];

// Turn a stored bodymap response ("wrist_l,low_back") into readable labels.
export const bodymapLabels = (resp) =>
  String(resp || '').split(',').filter(Boolean).map(k => REGION_LABEL[k] || k);
